import { getAssetIconComponent } from "@/data/assetMapping";
import type { IAssetImageV2Props } from "./types";
import type { IAsset } from "findef";
import { SymbolImage } from "components/symbol-image";
import { resolveAssetImageSources } from "@/utils/asset/resolveImage";

export const AssetImageV2 = defineComponent<IAssetImageV2Props>(
  (props) => {
    const investment = computed(() => unref(props.investment));
    const asset = computed(() => {
      const a = unref(props.asset);
      if (a) return a;
      const inv = investment.value;
      if (inv && inv.asset && typeof inv.asset === "object") {
        return inv.asset as IAsset;
      }
      return a;
    });

    const fallback = computed(() => {
      const inv = investment.value;
      let ass = asset.value;
      if (!ass && inv && inv.asset && typeof inv.asset === "object") {
        const invAsset = inv.asset as IAsset;
        ass = invAsset;
      }

      if (ass) {
        const IconComponent = getAssetIconComponent(ass, {
          fill: "currentColor",
          size: "80%",
          ...(props.iconProps || {}),
          style: {
            textAlign: 'center',
            display: 'grid',
            justifyItems: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%'
          },
        });
        return <IconComponent />;
      }

      return null;
    });

    const sources = computed(() =>
      resolveAssetImageSources(asset.value as Partial<IAsset>, investment.value as any),
    );

    return () => {
      return (
        <SymbolImage
          fallback={fallback}
          sources={sources}
          size={props.size}
          rounded={props.rounded}
          variant={props.variant}
          onLoad={props.onLoad}
          onError={props.onError}
          objectFit={props.objectFit}
        />
      );
    };
  },
  {
    props: [
      "fallback",
      "symbol",
      "rounded",
      "sources",
      "onLoad",
      "onError",
      "variant",
      "size",
      "asset",
      "investment",
      "iconProps",
      "objectFit",
    ],
  },
);
